export const MAX_ESTIMATE_RETRIES = 2;
export const MAX_VANTAGE_RETRIES = 2;